import React from "react"
import PropTypes from "prop-types"

class NotificationItem extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    return(
      <div onClick={() => this.props.onClick(this.props.notification.id)} className="wrapper_form_dark form_section" style={{border: '#01579b 2px solid', marginTop: 10, cursor: 'pointer'}}>
        <img
          src={this.props.closeIcon}
          style={{
            position: 'absolute',
            right: 0,
            marginTop: -10,
            paddingRight: 5,
            height: 20,
          }}/>
        <h2 className="heading_standard">{this.props.notification.notes}</h2>
      </div>
    )
  }

}
export default NotificationItem;
